import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { SignalInformation } from '../../models';


@Injectable({
    providedIn: 'root',
})
export class SignalInformationService extends ApiService {

    get(id: string) {
        return this.http.get(`${this.persionBaseURL}/api/signalinformation/${id}`);
    }
    
    getPersonSignalInformation(personId: string) {
        return this.http.get(`${this.persionBaseURL}/api/signalinformation/persons/${personId}/signalinformation`);
    }

    create(address: SignalInformation) {
        return this.http.post(`${this.persionBaseURL}/api/signalinformation`, address);
    }

    update(address: SignalInformation) {
        return this.http.put(`${this.persionBaseURL}/api/signalInformation`, address);
    }
    updateClinicPatient(id:string,address: SignalInformation) {
        return this.http.put(`${this.clinicsBaseURL}/api/clinicPatients/${id}/SignalInformation`, address);
    }
}
